import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Table,
  CustomInput,
} from 'reactstrap';
import {
  gAPI_Messenger_List_Bulk_Update,
  gAPI_Messenger_List_Translate,
} from '../../../../../../constants/APIs';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';

export default function AutoTranslateModal({
  isOpen,
  toggle,
  propertyLanguages,
  messengerList,
  languageCode,
  LoadData,
}) {
  const [sourceLanguage, setSourceLanguage] = useState('');
  const [targetLanguage, setTargetLanguage] = useState(languageCode || '');
  const [step, setStep] = useState(1);
  const [previewData, setPreviewData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const handlePreview = async () => {
    const dataToSend = messengerList.map((item) => {
      const buttonText = item.submitButtonText;
      return {
        id: item.id,
        title: item.title || '',
        description: item.displayText || '',
        textButton: buttonText,
      };
    });

    const initialPreviewData = messengerList.map((item) => {
      const buttonText = item.submitButtonText;
      return {
        id: item.id,
        title: item.title || '',
        description: item.displayText || '',
        buttonText: buttonText,
        translatedTitle: '',
        translatedDescription: '',
        translatedButtonText: '',
      };
    });

    setPreviewData(initialPreviewData);
    setSelectedItems([]);
    setStep(2);
    setLoading(true);

    try {
      const payload = {
        sourceLang: sourceLanguage,
        targetLang: targetLanguage,
        data: dataToSend,
      };

      const response = await AxiosAPI({
        method: 'POST',
        url: gAPI_Messenger_List_Translate,
        data: payload,
      });
      const result = response.data;

      const translatedData = messengerList.map((item) => {
        const buttonText = item.submitButtonText;

        const translationItem = result.translations?.find(
          (t) => t.original.id == item.id
        );

        // console.log('translationItem mk..............', {
        //   translationItem,
        //   result,
        //   item,
        //   messengerList,
        //   propertyLanguages,
        // });
        return {
          id: item.id,
          title: item.title || '',
          description: item.displayText || '',
          buttonText: buttonText,
          translatedTitle: translationItem
            ? translationItem.translated.title
            : item.title || '',
          translatedDescription: translationItem
            ? translationItem.translated.description
            : item.displayText || '',
          translatedButtonText: translationItem
            ? translationItem.translated.textButton
            : buttonText,
        };
      });

      setPreviewData(translatedData);
      setSelectedItems([]);
      setStep(2);
    } catch (error) {
      console.error('Translation API error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleItem = (id) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((i) => i !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleToggleAll = () => {
    if (selectedItems.length === previewData.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(previewData.map((d) => d.id));
    }
  };

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      const selectedData = selectedItems.map((id) =>
        previewData.find((d) => d.id === id)
      );

      const payload = {
        updates: selectedData.map((data) => ({
          id: data.id,
          title: {
            statement: data.translatedTitle,
            languageCode: targetLanguage,
          },
          displayText: {
            statement: data.translatedDescription,
            languageCode: targetLanguage,
          },
          submitButtonText: {
            statement: data.translatedButtonText,
            languageCode: targetLanguage,
          },
        })),
      };

      const response = await AxiosAPI({
        method: 'PUT',
        url: gAPI_Messenger_List_Bulk_Update,
        data: payload,
      });

      LoadData(targetLanguage);

      // console.log('Bulk update response:', response.data);

      toggle();
      setStep(1);
      setSourceLanguage('');
      setSelectedItems([]);
      setPreviewData([]);
    } catch (error) {
      console.error('Translation save error:', error);
    } finally {
      setSaveLoading(false);
    }
  };


  useEffect(() => {

    if (languageCode) {
      setTargetLanguage(languageCode)
    }

  }, [languageCode])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Auto Translate</ModalHeader>
      <ModalBody>
        {step === 1 && (
          <>
            <FormGroup>
              <Label>Select Source Language</Label>
              <Input
                type="select"
                value={sourceLanguage}
                onChange={(e) => setSourceLanguage(e.target.value)}
              >
                <option value="">Select a language</option>
                {propertyLanguages &&
                  propertyLanguages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                      {lang.name || lang.code}
                    </option>
                  ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label>Select Target Language</Label>
              <Input
                type="select"
                value={targetLanguage === 'hk' ? 'zh-TW' : targetLanguage}
                onChange={(e) => setTargetLanguage(e.target.value)}
                disabled={true}
              >
                <option value="">Select a language</option>
                {propertyLanguages &&
                  propertyLanguages.map((lang) => (
                    <option key={lang.code} value={lang.code}>
                      {lang.name || lang.code}
                    </option>
                  ))}
              </Input>
            </FormGroup>
          </>
        )}
        {step === 2 && (
          <Table responsive bordered>
            <thead>
              <tr>
                <th style={{ width: '50px' }}>
                  <CustomInput
                    type="checkbox"
                    id="selectAllTranslations"
                    label=""
                    checked={
                      selectedItems.length === previewData.length &&
                      previewData.length > 0
                    }
                    onChange={handleToggleAll}
                  />
                </th>
                <th>Item</th>
                <th>Current Text</th>
                <th>Translated Text</th>
              </tr>
            </thead>
            <tbody>
              {previewData.map((data) => {
                const topBorderOnly = { borderBottom: 'none' };
                const noVerticalBorder = {
                  borderTop: 'none',
                  borderBottom: 'none',
                };
                const bottomBorderOnly = { borderTop: 'none' };

                return (
                  <React.Fragment key={data.id}>
                    <tr>
                      <td
                        rowSpan="3"
                        style={{ verticalAlign: 'middle', width: '50px' }}
                      >
                        <CustomInput
                          type="checkbox"
                          id={`translate-item-${data.id}`}
                          label=""
                          checked={selectedItems.includes(data.id)}
                          onChange={() => handleToggleItem(data.id)}
                        />
                      </td>
                      <td
                        style={{
                          ...topBorderOnly,
                          whiteSpace: 'nowrap',
                          width: '120px',
                        }}
                      >
                        <strong>Title:</strong>
                      </td>
                      <td style={topBorderOnly}>{data.title}</td>
                      <td style={topBorderOnly}>
                        {loading ? (
                          <div
                            className="integration-text-skeleton-loader"
                            style={{
                              width: '80%',
                              height: '18px',
                              display: 'inline-block',
                            }}
                          ></div>
                        ) : (
                          data.translatedTitle
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...noVerticalBorder, whiteSpace: 'nowrap' }}>
                        <strong>Description:</strong>
                      </td>
                      <td
                        style={{ ...noVerticalBorder, wordBreak: 'break-word' }}
                      >
                        {data.description}
                      </td>
                      <td
                        style={{ ...noVerticalBorder, wordBreak: 'break-word' }}
                      >
                        {loading ? (
                          <div
                            className="integration-text-skeleton-loader"
                            style={{
                              width: '100%',
                              height: '18px',
                              display: 'inline-block',
                            }}
                          ></div>
                        ) : (
                          data.translatedDescription
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ ...bottomBorderOnly, whiteSpace: 'nowrap' }}>
                        <strong>Button Text:</strong>
                      </td>
                      <td style={bottomBorderOnly}>{data.buttonText}</td>
                      <td style={bottomBorderOnly}>
                        {loading ? (
                          <div
                            className="integration-text-skeleton-loader"
                            style={{
                              width: '40%',
                              height: '18px',
                              display: 'inline-block',
                            }}
                          ></div>
                        ) : (
                          data.translatedButtonText
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        )}
      </ModalBody>
      <ModalFooter>
        {step === 1 ? (
          <Button
            color="primary"
            disabled={!sourceLanguage || loading}
            onClick={handlePreview}
          >
            {loading ? 'Translating...' : 'Preview Translation'}
          </Button>
        ) : (
          <Button
            color="primary"
            disabled={selectedItems.length === 0 || loading || saveLoading}
            onClick={handleSave}
          >
            {loading
              ? 'Translating...'
              : saveLoading
                ? 'Saving...'
                : 'Save Translation'}
          </Button>
        )}
        <Button
          color="secondary"
          onClick={() => {
            toggle();
            setStep(1);
            setSourceLanguage('');
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
